// removed by extract-text-webpack-plugin
module.exports = {"email":"src-components-Messages-styles-__email__email--2bZEh","topsIndex":"src-components-Messages-styles-__email__topsIndex--sT0qP","isSelected":"src-components-Messages-styles-__email__isSelected--pH899","sender":"src-components-Messages-styles-__email__sender--1PQI3","date":"src-components-Messages-styles-__email__date--2seKS","iframe":"src-components-Messages-styles-__email__iframe--31Qcz","showLess":"src-components-Messages-styles-__email__showLess--26PDO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/styles/email.css
// module id = 1976
// module chunks = 0